import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface LoaderProps {
  size?: number; // Tamaño del spinner
  text?: string; // Texto opcional a mostrar debajo del spinner
}

const Loader: React.FC<LoaderProps> = ({ size = 40, text }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
    >
      <CircularProgress size={size} />
      {text && (
        <Typography variant="body1" style={{ marginTop: "1rem" }}>
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;
